import { Injectable } from '@angular/core';
import {
  AppUpdate,
  AppUpdateAvailability,
} from '@capawesome/capacitor-app-update';

@Injectable({
  providedIn: 'root',
})
export class AppUpdateService {
  constructor() {}

  async getAppUpdateInfo() {
    return await AppUpdate.getAppUpdateInfo({ country: 'ID' });
  }

  async getCurrentVersion() {
    const result = await AppUpdate.getAppUpdateInfo({ country: 'ID' });
    return result.currentVersionName;
  }

  async getAvailableAppVersion() {
    const result = await AppUpdate.getAppUpdateInfo({ country: 'ID' });
    return result.availableVersionName;
  }

  async performImmidiateUpdate() {
    const result = await AppUpdate.getAppUpdateInfo();
    if (result.updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) {
      return;
    }
    if (result.immediateUpdateAllowed) {
      await AppUpdate.performImmediateUpdate();
    }
  }

  async performFlexibleUpdate() {
    const result = await AppUpdate.getAppUpdateInfo();
    if (result.updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) {
      return;
    }
    if (result.immediateUpdateAllowed) {
      await AppUpdate.startFlexibleUpdate();
    }
  }

  async completeFLexibleUpdate() {
    await AppUpdate.completeFlexibleUpdate();
  }

  async openAppStore() {
    await AppUpdate.openAppStore({
      appId: '1665792615',
      androidPackageName: 'com.badungkab.sikapbadung',
    });
  }
}
